/**
 * Format a number with dec
 */
export const numberFormat = (number) => {
  return new Intl.NumberFormat({
    style: 'decimal'
  }).format(number)
}
